// @ngInject
function DeliveryPlanningTemplatesApiService(ResourcesService) {

    var endpoint = 'deliveryplanningtemplate';

    return {
        getDeliveryPlanningTemplates: ResourcesService.apiFactory.get(endpoint),
        getDeliveryPlanningTemplate: ResourcesService.apiFactory.get(endpoint),
        createDeliveryPlanningTemplate: ResourcesService.apiFactory.create(endpoint, 'DeliveryPlanningTemplate'),
        updateDeliveryPlanningTemplate: ResourcesService.apiFactory.update(endpoint, 'DeliveryPlanningTemplate'),
        deleteDeliveryPlanningTemplate: ResourcesService.apiFactory.delete(endpoint, 'DeliveryPlanningTemplate')
    };
}

angular
    .module('deliveryplanningtemplates.api', [])
    .factory('DeliveryPlanningTemplatesApiService', DeliveryPlanningTemplatesApiService);